import { defineComponent as _defineComponent } from 'vue'
import { VButton } from 'ah-common-lib/src/common/components';
import { useToast } from 'ah-common-lib/src/toast';
import { ToastType } from 'ah-common-lib/src/toast/toastInterfaces';
import QueryStringTabs from 'ah-common-lib/src/common/components/QueryStringTabs.vue';
import { ref } from 'vue';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';
import WarningSplash from 'bd-common/src/components/common/WarningSplash.vue';
import NotificationsList from 'bd-common/src/components/notifications/NotificationsList.vue';
import {
  BHTradeStatus,
  DocumentExportType,
  Notification,
  NotificationAlertType,
  NotificationResourceType,
  NotificationType,
} from 'ah-api-gateways';
import TradeStatusPill from 'ah-trades/src/components/tableCells/TradeStatusPill.vue';
import { FormDefinition } from 'ah-common-lib/src/form/interfaces';
import { emailField, phoneField, textField } from 'ah-common-lib/src/form/models';
import { makeFormModel } from 'ah-common-lib/src/form/helpers';
import { ValidatedForm } from 'ah-common-lib/src/form/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'KitchenSinkView',
  setup(__props) {

const formDef = ref<FormDefinition>({
  form: makeFormModel({
    name: 'contactDetailsForm',
    title: 'Contact Details',
    fieldType: 'form',

    fields: [
      textField('title', 'Mandatory field', { required: true }),
      textField('firstName', 'Readonly field', { fieldWrapperClass: 'col-6 pr-0', required: false, readonly: true }),
      textField('lastName', 'Optional field', { required: false }),
      emailField('email', 'Email'),
      phoneField('phoneNumber', 'Mobile Number', {
        required: true,
        errorMessages: {
          required: 'This field is mandatory',
        },
      }),
    ],
  }),
  validation: null,
});

const statusList: BHTradeStatus[] = [
  BHTradeStatus.OPEN,
  BHTradeStatus.CLOSED,
  BHTradeStatus.AMENDED,
  BHTradeStatus.REJECTED,
  BHTradeStatus.REMAINING_CANCELING,
  BHTradeStatus.REMAINING_CANCELED,
  BHTradeStatus.DATE_ROLLED,
  BHTradeStatus.REMAINING_DATE_ROLLED,
  BHTradeStatus.FULLY_SETTLED,
  BHTradeStatus.REMAINING_SETTLED,
  BHTradeStatus.OVERDUE,
  BHTradeStatus.SETTLES_TODAY,
  BHTradeStatus.SUBMITTED,
  BHTradeStatus.PARTIALLY_OPEN,
  BHTradeStatus.CANCELING,
  BHTradeStatus.REMAINING_CLOSED,
  BHTradeStatus.VERIFIED,
];

const toast = useToast();

const notifications = ref<Notification[]>([
  {
    id: '1',
    alertType: NotificationAlertType.REGULAR,
    title: 'Notification one',
    message: 'This is a regular notification',
    createdAt: '2024-02-15T14:14:55.729Z',
    read: false,
    resourceType: NotificationResourceType.CLIENT_UUID,
    type: NotificationType.CLIENT_STATUS_UPDATE,
  },
  {
    id: '2',
    alertType: NotificationAlertType.REGULAR,
    title: 'Payments List',
    message: 'XLSX Document is ready to download',
    createdAt: '2024-02-14T12:14:55.729Z',
    read: false,
    resource: 'res3',
    resourceOrigin: DocumentExportType.EOM_STATEMENT,
    resourceType: NotificationResourceType.DOCUMENT_UUID,
    type: NotificationType.DOCUMENT_STATUS_EXPORTED,
  },
  {
    id: '3',
    alertType: NotificationAlertType.URGENT,
    title: 'Payments List',
    message: 'XLSX Document is ready to download',
    createdAt: '2024-02-13T12:14:55.729Z',
    read: false,
    resource: 'res3',
    resourceOrigin: DocumentExportType.EOM_STATEMENT,
    resourceType: NotificationResourceType.DOCUMENT_UUID,
    type: NotificationType.TRADE_CONFIRMED,
  },
  {
    id: '4',
    alertType: NotificationAlertType.REGULAR,
    title: 'Notification four',
    message: 'This is a regular notification',
    createdAt: '2024-02-12T14:14:55.729Z',
    read: true,
    resourceType: NotificationResourceType.CLIENT_UUID,
    type: NotificationType.CLIENT_STATUS_UPDATE,
  },
  {
    id: '5',
    alertType: NotificationAlertType.REGULAR,
    title: 'Payments List',
    message: 'PDF Document is ready to download',
    createdAt: '2024-02-11T12:14:55.729Z',
    read: true,
    resource: 'res5',
    resourceOrigin: DocumentExportType.EOM_STATEMENT,
    resourceType: NotificationResourceType.DOCUMENT_UUID,
    type: NotificationType.DOCUMENT_STATUS_EXPORTED,
  },
  {
    id: '6',
    alertType: NotificationAlertType.URGENT,
    title: 'Payments List',
    message: 'XLSX Document is ready to download',
    createdAt: '2024-02-10T12:14:55.729Z',
    read: true,
    resource: 'res3',
    resourceOrigin: DocumentExportType.EOM_STATEMENT,
    resourceType: NotificationResourceType.DOCUMENT_UUID,
    type: NotificationType.TRADE_CONFIRMED,
  },
]);

const buttonsDisabled = ref(false);
const isUseSwitches = ref(false);

return { __sfc: true,formDef, statusList, toast, notifications, buttonsDisabled, isUseSwitches, VButton, ToastType, QueryStringTabs, MaterialIcon, WarningSplash, NotificationsList, TradeStatusPill, ValidatedForm }
}

})